import classnames from "classnames";
import classes from "../../../styles/Resources.module.scss";
import Banner from "../../../components/common/Banner/Banner";
import BannerType from "../../../global/banner-type";
import resources from "../../../assets/images/resources.png";
import { healthcaredata, faq } from "../../../global/constant";
import ContentSection from "../../../components/common/ContentSection/ContentSection";
import useIsMobile from "../../../components/hooks/useIsMobile";

const Blog = () => {
  const isMobile = useIsMobile({ breakpoint: 992 });
  return (
    <div className={classnames(classes.main_content)}>
      <div className={classnames(classes.bannerSection)}>
        <Banner
          type={BannerType.SINGLE_IMAGE_BANNER}
          title="Blog"
          description="Online writing platform for sharing ideas & experiences."
          image={resources}
          maxWidth={214}
          className={classes.containerWidth}
        />
      </div>
      <div
        style={{
          margin: isMobile ? "16px 0" : "16px",
          height: "320px",
          position: "relative",
          backgroundColor: "#F1F5F9",
        }}
      >
        <div
          style={{
            fontWeight: 600,
            fontSize: "1.125rem",
            color: "#0f172a",
          }}
          className="center"
        >
          Blog Features Coming soon!
          <div
            style={{
              fontSize: "0.75rem",
              color: "#64748B",
            }}
          >
            Something really cool is coming.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
